import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { useLocalization } from 'localization';
import { CurrencyCode } from 'constants/enums/general';
import useGetKeyPickUpFee from 'hooks/services/useGetKeyPickUpFee';
import { calculatePriceInTotal } from 'helpers/calculatePriceInTotal';
import hasBookPhotographerTask from 'helpers/hasBookPhotographerTask';

const useNewOrderCalculatePrice = () => {
  const { watch } = useFormContext();
  const { f } = useLocalization();
  const keyPickUpFee = useGetKeyPickUpFee();

  const basicPackage = watch('basicPackage')?.discountedPrice ?? 0;
  const bundlePackagesProduct = calculatePriceInTotal(watch('bundlePackagesProduct')) ?? 0;
  const singleProducts = calculatePriceInTotal(watch('singleProducts')) ?? 0;
  const isKeyPickupChosen = watch('keyPickup') && hasBookPhotographerTask() ? keyPickUpFee.price : 0;
  const packageCurrency = CurrencyCode.DKK;

  const { totalPrice, currency } = useMemo(() => {
    return {
      totalPrice: basicPackage + bundlePackagesProduct + singleProducts + isKeyPickupChosen,

      currency: packageCurrency,
    };
  }, [basicPackage, bundlePackagesProduct, singleProducts, isKeyPickupChosen]);
  return f(totalPrice || 0, { currency, decimals: 2 });
};

export default useNewOrderCalculatePrice;
